import React, { useState } from "react";

const AppLink = ({
  src,
  href,
  mobile,
  changeBaseUrl,
  title,
  logo,
  buttons,
  handleClick,
  purpleEdgeTint,
  logoClassName,
}) => {
  const [displayOverlay, setDisplayOverlay] = useState(false);

  const renderOverlay = () => {
    if (displayOverlay) {
      return <div className="app-link-overlay"></div>;
    }
  };

  const openLink = (url, changeBase = false) => {
    if (changeBase) {
      window.open(url);
    } else {
      window.open(url, "_self");
    }
  };

  const handleContainerClick = () => {
    if (typeof handleClick === "function") handleClick();
    openLink(href, changeBaseUrl);
  };

  const hasButtons = buttons && Array.isArray(buttons) && buttons.length > 0;

  const renderButtons = () => {
    if (!hasButtons) return null;
    return (
      <div className="d-flex flex-column gap-3 align-items-center app-link-buttons">
        {buttons.map((item, index) => (
          <a
            key={index}
            href={item.url}
            className="btn text-white bold px-4 px-md-5 fs-5 btn-primary app-link-btn"
            style={{ borderRadius: "40px", height: "60px", minWidth: "200px" }}
            onClick={(e) => {
              e.stopPropagation();
              if (typeof item.handleClick === "function") item.handleClick();
            }}
            rel={item.changeBaseUrl ? "noopener noreferrer" : undefined}
            target={item.changeBaseUrl ? "_blank" : undefined}
          >
            {item.label}
            <i className="fas fa-arrow-right ms-2" />
          </a>
        ))}
      </div>
    );
  };

  const renderLogo = () => {
    if (hasButtons) return null;
    if (!logo) return null;
    if (Array.isArray(logo)) {
      return (
        <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center app-link-logos d-block">
          {logo.map((item, index) => (
            <a
              key={index}
              href={item.url}
              className="app-link-logo-link d-block"
              onClick={(e) => e.stopPropagation()}
              rel={item.changeBaseUrl ? "noopener noreferrer" : undefined}
              target={item.changeBaseUrl ? "_blank" : undefined}
            >
              <img
                src={item.src}
                className={[
                  "app-link-logo",
                  logoClassName,
                ]
                  .filter(Boolean)
                  .join(" ")}
                alt=""
              />
            </a>
          ))}
        </div>
      );
    }
    return (
      <img
        src={logo}
        className={["app-link-logo", logoClassName].filter(Boolean).join(" ")}
        alt="logo"
      />
    );
  };

  return (
    <div
      className="col-12 col-md-4 px-0 app-link "
      onClick={handleContainerClick}
      onMouseEnter={() => setDisplayOverlay(true)}
      onMouseLeave={() => setDisplayOverlay(false)}
    >
      <div
        className="h-100 w-100 home-img position-relative d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundImage: `url(${
            window.innerWidth < 767 && mobile && mobile !== null ? mobile : src
          })`,
        }}
      >
        {purpleEdgeTint ? (
          <div className="app-link-edge-tint" aria-hidden />
        ) : null}
        <div className="d-flex flex-column align-items-center app-link-stacked">
          {title && (
            <div className="app-link-stacked__title">
              <h2 className="app-link__title mb-2 mb-md-3">{title}</h2>
            </div>
          )}
          <div className="app-link-stacked__content">
            {renderButtons() || renderLogo()}
          </div>
        </div>
        {renderOverlay()}
      </div>
    </div>
  );
};

export default AppLink;
